import { Component } from '@angular/core';
import { NgForOf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PublicNavigationComponent } from "../public-navigation/public-navigation.component";
import { PublicFooterComponent } from "../footer/footer.component";

@Component({
  selector: 'app-features',
  standalone: true,
  templateUrl: './features.component.html',
  styleUrl: './features.component.scss',
  imports: [NgForOf, RouterLink, PublicNavigationComponent, PublicFooterComponent]
})
export class FeaturesComponent {
  features = [
    // color: any Bootstrap contextual color or hex
    {
      icon: 'fa-list-check',
      color: '#0d6efd',
      title: 'Aufgabenstatus',
      desc:
        'Aufgaben können die Status Neu, In Bearbeitung, Erledigt oder Abgesagt haben. Der Status lässt sich je Aufgabe ändern.',
    },
    {
      icon: 'fa-tags',
      color: '#20c997',
      title: 'Aufgabentypen',
      desc:
        'Aufgaben lassen sich einem Typ zuordnen (z. B. Anfrage, Bestellung, Reklamation, Supportfall).',
    },
    {
      icon: 'fa-user-tie',
      color: '#6f42c1',
      title: 'Zuordnung zu Kunde oder Kontakt',
      desc:
        'Aufgaben können einem Kunden oder einem Kontakt (Person) zugeordnet werden. Schnellsuche ist verfügbar.',
    },
    {
      icon: 'fa-calendar-day',
      color: '#fd7e14',
      title: 'Fälligkeit & Erinnerung',
      desc:
        'Für Aufgaben können Fälligkeits- und Erinnerungstermine gesetzt werden. Erinnerungen sind in einer Übersicht einsehbar.',
    },
    {
      icon: 'fa-building',
      color: '#198754',
      title: 'Abteilungen & Bearbeiter',
      desc:
        'Aufgaben können Abteilungen zugewiesen und ein Bearbeiter gesetzt werden.',
    },
    {
      icon: 'fa-microphone',
      color: '#dc3545',
      title: 'Sprachnotiz aufnehmen',
      desc:
        'Spezial-Funktion: Audio kann direkt im Aufgaben-Detail aufgenommen und als Anhang gespeichert werden.',
    },
    {
      icon: 'fa-box-archive',
      color: '#0dcaf0',
      title: 'Archivierung',
      desc:
        'Abgeschlossene Aufgaben können archiviert und bei Bedarf wiederhergestellt werden.',
    },
    {
      icon: 'fa-bell',
      color: '#6610f2',
      title: 'Erinnerungsübersicht',
      desc:
        'Es gibt eine Seite zur Übersicht offener Erinnerungen mit direkter Navigation zur Aufgabe.',
    },
    {
      icon: 'fa-database',
      color: '#6c757d',
      title: 'Stammdatenverwaltung',
      desc:
        'Einfache Verwaltung von Benutzern, Kontakten, Kunden, Abteilungen und Aufgabentypen.',
    },
  ];
}
